// any app specific constants that you don't want to keep in config can go here.
export const SYSTEM_ERROR = "System error. Please try again later!";
export const CTA_YES = "Yes";
export const CTA_NO = "No";
export const CTA_CANCEL = "Cancel";

//constants for job Status
export const COMPLETED = "COMPLETED";
export const ONBOARDING_COMPLETED = "COMPLETED";
export const ONBOARDING_STARTED = "STARTED";
export const ONBOARDING_ERROR = "ERROR";
export const ONBOARDING_NOT_STARTED = "NOT_STARTED";
export const ONBOARDING_FAILED = "FAILED";

export const MANUAL_JOB_STARTED = "STARTED";

export const SEVEN_DAYS_JOB_STATUS = "7daysStatus";
export const SIXTY_DAYS_JOB_STATUS = "60daysStatus";
export const HISTORICAL_JOB_STATUS = "historicalJobStatus";

export const CUSTOM_TIME_FRAME_OPTION = 1;
export const SAME_MONTH_LAST_YEAR_TIME_FRAME_OPTION = 2;
export const NINTY_DAYS_TIME_FRAME_OPTION = 90;
export const TIME_FRAME_NUMBER_DAYS_ALLOWED = 90;

export const MAX_DAYS_HISTORICAL_DATA_AVAILABLE = 365;

export const FORECAST_SALES_TIMEFRAME_OPTIONS = [
  { label: "Last 7 days", value: 7, timeframeDays: 7 },
  { label: "Last 14 days", value: 14, timeframeDays: 14 },
  { label: "Last 30 days", value: 30, timeframeDays: 30 },
  { label: "Last 60 days", value: 60, timeframeDays: 60 },
  {
    label: "Last 90 days",
    value: NINTY_DAYS_TIME_FRAME_OPTION,
    timeframeDays: 90,
  },
  {
    label: "Same month last year",
    value: SAME_MONTH_LAST_YEAR_TIME_FRAME_OPTION,
    timeframeDays: 365,
  },
  { label: "Custom Range", value: CUSTOM_TIME_FRAME_OPTION, timeframeDays: 0 },
];

export const DESCENDING_SORT_DIRECTION = "desc";
export const ACENDING_SORT_DIRECTION = "asc";

export const SALES_TIMEFRAME_MAX_START_DATE_RANGE = 60;
export const INCOMING_INVENTORY_PER_PAGE = 10;
export const DEFAULT_INCOMING_INVENTORY_SORT = "arrival_date";

export const FORECAST_REPORT_PRODUCT_STATUS_ACTIVE = "ACTIVE";
export const FORECAST_REPORT_PRODUCT_STATUS_ALL = "ALL";
export const TODAY = "Today";


//article numbers from the intercom which shows how to access historical orders.
export const HOW_TO_ACCESS_HISTORICAL_ORDERS = 8349364;

// Define the thumbnail size suffix (_40x40: 40x40 pixels, @2x is the resoultion multiplier)
export const IMAGE_THUMBNAIL_SIZE = "_40x40@2x"

export const FORECAST_LEAD_TIME_AND_DAYS_OF_STOCK_SELECTION_STEP = 0;
export const TIMEFRAME_PERIOD_SELECTION_STEP = 1;
export const TIMEFRAME_PERIOD_DATE_SELECTION_STEP = 2;
export const TIMEFRAME_PERIOD_SAVE_AND_VIEW_RESULTS_STEP = 3;
export const DISPLAY_REORDER_QUANTIY_AND_DEADLINE_STEP = 4;
export const SCHEDULE_CALL_STEP = 5;

export const ONBOARDING_WALKTHROUGH_STEP_1 = 1;
export const ONBOARDING_WALKTHROUGH_STEP_2 = 2;
export const ONBOARDING_WALKTHROUGH_STEP_3 = 3;
export const ONBOARDING_WALKTHROUGH_STEP_4 = 4;
export const ONBOARDING_WALKTHROUGH_STEP_5 = 5;

export const ACCOUNT_SETTINGS_TAB = 0;
export const EMAIL_RECIPIENTS_TAB = 1;
export const PLAN_BILLING_TAB = 2;
export const FORECAST_SETTINGS_TAB = 3;
export const LOCATION_SETTINGS_TAB = 4;
export const EXCLUDE_FROM_FORECASTING_TAB = 5;
export const CUSTOM_OPTIONS_TAB = 6;

// Side-nav rows inside the "Exclude from Forecasting" tab
export const EXCLUDE_BY_PRODUCT_TAG_SUBTAB = 0;
export const EXCLUDE_BY_ORDER_TAG_SUBTAB = 1;

// GOTO params are 1-based indices used in URLs (e.g., /ui/settings?goto=1)
// Define explicitly to mirror Account.jsx goToTab mapping
export const ACCOUNT_SETTINGS_GOTO = 1; // maps to ACCOUNT_SETTINGS_TAB (0)
export const EMAIL_RECIPIENTS_GOTO = 2; // maps to EMAIL_RECIPIENTS_TAB (1)
export const FORECAST_SETTINGS_GOTO = 3; // maps to FORECAST_SETTINGS_TAB (3)
// Both GOTO values below open EXCLUDE_FROM_FORECASTING_TAB (5); they only differ
// in which side-nav row (sub-tab) gets preselected inside that tab.
export const EXCLUDE_BY_TAG_GOTO = 4; // maps to EXCLUDE_FROM_FORECASTING_TAB (5), Exclude by Product Tag sub-tab
export const PLAN_BILLING_GOTO = 5; // maps to PLAN_BILLING_TAB (2)
export const CUSTOM_OPTIONS_GOTO = 6; // maps to CUSTOM_OPTIONS_TAB (6)
export const LOCATION_SETTINGS_GOTO = 7; // maps to LOCATION_SETTINGS_TAB (4)
export const EXCLUDE_ORDERS_BY_TAG_GOTO = 8; // maps to EXCLUDE_FROM_FORECASTING_TAB (5), Exclude by Order Tag sub-tab